export const COLOURS = {
  RED: '#E01A22',
  DARK_RED: '#A30006',
  WHITE: '#FFF',
  BLACK_100: '#F4F4F4',
  BLACK_200: '#E9E9E9',
  BLACK_300: '#b3b3b3',
  BLACK_500: '#8F8F8E',
  BLACK_700: '#6E6E6D',
  BLACK_750: '#474A45',
  BLACK_800: '#414240',
  BLACK_900: '#20211F',
  BLACK: '#000',
  BEIGE: '#EBE5DA',
  SUCCESS_BASE: '#0E8A4F',
  SUCCESS_DARK: '#097B48',
  ERROR_BASE: '#DB3833',
  ERROR_DARK: '#C83532',
  LINK_HOVER: '#fce8e9',
};

const BORDER_WIDTHS = {
  FINE: '1px',
  NORMAL: '2px',
  THICK: '3px',
};

const THEME = {
  TEXT: {
    HEADING: COLOURS.BLACK,
    BODY: COLOURS.BLACK_900,
    LINK: COLOURS.RED,
    ERROR: COLOURS.RED,
    ACTIVE: COLOURS.DARK_RED,
    WHITE: COLOURS.WHITE,
  },
  FIELD: {
    BORDER: {
      LIGHT: COLOURS.BLACK_200,
      INPUT: COLOURS.BLACK_500,
      DEFAULT: COLOURS.BLACK_700,
      DARK: COLOURS.BLACK,
      VALID: COLOURS.SUCCESS_BASE,
      INVALID: COLOURS.ERROR_BASE,
      ACTIVE: COLOURS.DARK_RED,
      NORMAL: BORDER_WIDTHS.NORMAL,
      SELECTED: BORDER_WIDTHS.THICK,
    },
  },
  ICON: {
    VALID: COLOURS.SUCCESS_BASE,
    INVALID: COLOURS.ERROR_BASE,
  },
  LINK: {
    DEFAULT: COLOURS.RED,
    ACCESSIBLE: COLOURS.DARK_RED,
    HOVER: COLOURS.LINK_HOVER,
  },
  BACKGROUND: {
    CARD: COLOURS.BEIGE,
    FLYBUYS: COLOURS.BLACK_100,
    WHITE: COLOURS.WHITE,
    HEADING: COLOURS.BLACK_100,
    DARK: COLOURS.BLACK,
    FOCUS: COLOURS.BLACK_800,
  },
  PAYMENT_CONFIRMATION_CONTAINER: {
    BORDER: COLOURS.BLACK_200,
  },
  SIDEBAR: {
    BORDER: COLOURS.BLACK_500,
  },
  TICK_ICON: {
    VALID: COLOURS.SUCCESS_BASE,
    DEFAULT: COLOURS.BLACK_300,
  },
  BADGE: {
    BACKGROUND: {
      PRIMARY: COLOURS.RED,
      SECONDARY: COLOURS.BLACK_750,
      WHITE: COLOURS.WHITE,
      TIERTARY: COLOURS.WHITE,
    },
    TEXT: {
      PRIMARY: COLOURS.WHITE,
      SECONDARY: COLOURS.WHITE,
      RED: COLOURS.RED,
      TIERTARY: COLOURS.RED,
    },
    BORDER: {
      TIERTARY: COLOURS.RED,
    },
  },
  CARD: {
    BORDER: COLOURS.BLACK_200,
  },
  HEADING: {
    BORDER: COLOURS.RED,
  },
};

export default THEME;
